import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table table-bordered"
}
const _hoisted_2 = { class: "sticky-top bg-white" }
const _hoisted_3 = { class: "position-relative border-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "№ п/п", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Наименование", -1)
const _hoisted_6 = {
  key: 0,
  class: "py-2 px-3"
}
const _hoisted_7 = {
  key: 1,
  class: "py-2 px-3"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Сумма без НДС", -1)
const _hoisted_9 = {
  key: 0,
  class: "bg-light"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "py-2 px-3" }, [
  /*#__PURE__*/_createElementVNode("b", null, "I")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { class: "py-2 px-3" }, "Трудозатраты", -1)
const _hoisted_12 = {
  key: 0,
  class: "py-2 px-3"
}
const _hoisted_13 = {
  key: 1,
  class: "py-2 px-3 text-end"
}
const _hoisted_14 = { class: "py-2 px-3 text-end" }
const _hoisted_15 = { class: "py-2 px-3 fw-bold" }
const _hoisted_16 = { class: "py-2 px-3" }
const _hoisted_17 = {
  key: 0,
  class: "py-2 px-3"
}
const _hoisted_18 = {
  key: 1,
  class: "py-2 px-3 text-end"
}
const _hoisted_19 = { class: "py-2 px-3 text-end" }
const _hoisted_20 = {
  key: 1,
  class: "bg-light"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", { class: "py-2 px-3" }, [
  /*#__PURE__*/_createElementVNode("b", null, "II")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", { class: "py-2 px-3" }, "Материалы", -1)
const _hoisted_23 = {
  key: 0,
  class: "py-2 px-3"
}
const _hoisted_24 = {
  key: 1,
  class: "py-2 px-3 text-end"
}
const _hoisted_25 = { class: "py-2 px-3 text-end" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "py-2 px-3" }, null, -1)
const _hoisted_27 = { class: "py-2 px-3" }
const _hoisted_28 = { class: "py-2 px-3" }
const _hoisted_29 = { class: "py-2 px-3 text-end" }
const _hoisted_30 = { class: "py-2 px-3 text-end" }
const _hoisted_31 = { key: 3 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", { class: "py-2 px-3" }, [
  /*#__PURE__*/_createElementVNode("b", null, "III")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", { class: "py-2 px-3" }, "Субподряд", -1)
const _hoisted_34 = { class: "py-2 px-3 text-end text-nowrap" }
const _hoisted_35 = { class: "py-2 px-3 fw-bold" }
const _hoisted_36 = { class: "py-2 px-3" }
const _hoisted_37 = {
  key: 0,
  class: "py-2 px-3"
}
const _hoisted_38 = {
  key: 1,
  class: "py-2 px-3 text-end"
}
const _hoisted_39 = { class: "py-2 px-3 text-end" }
const _hoisted_40 = { class: "bg-light" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("td", { class: "py-2 px-3" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", { class: "py-2 px-3" }, "Итого", -1)
const _hoisted_43 = {
  key: 0,
  class: "py-2 px-3"
}
const _hoisted_44 = {
  key: 1,
  class: "py-2 px-3 text-end"
}
const _hoisted_45 = { class: "py-2 px-3 text-end" }

import { computed } from "vue";
import formatMoney from "@/utils/formatMoney";
import type { constructiveReportType, materialType } from "@/@types/ISectionJob";


export default /*#__PURE__*/_defineComponent({
  __name: 'CalculationReportTableComponent',
  props: {
    constructives: {
        type: Array<constructiveReportType>,
        required: true,
    },
    materials: {
        type: Array<materialType>,
        required: true,
    },
    isSectionJobPage: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {


const props = __props;

const constructiveTotals = computed(() => {
    return props.constructives.reduce((acc, constructive) => {
        acc.hoursWorked += constructive.hoursWorked;
        acc.total += constructive.total;
        return acc;
    }, {
        hoursWorked: 0,
        total: 0,
    });
});

const constructiveMaterialTotals = computed(() => {
    return props.constructives.reduce((acc, constructive) =>  acc += constructive.materialTotal, 0);
});

const materialTotals = computed(() => {
    return props.materials.reduce((acc, material) => {
        acc.count += Number(material.count);
        acc.total += Number(material.total);
        return acc;
    }, {
        count: 0,
        total: 0,
    });
});


return (_ctx: any,_cache: any) => {
  return (!!props.constructives.length || !!props.materials.length)
    ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _createElementVNode("thead", _hoisted_2, [
          _createElementVNode("tr", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            (!props.isSectionJobPage)
              ? (_openBlock(), _createElementBlock("th", _hoisted_6, "Ед изм"))
              : _createCommentVNode("", true),
            (!props.isSectionJobPage)
              ? (_openBlock(), _createElementBlock("th", _hoisted_7, "Количество"))
              : _createCommentVNode("", true),
            _hoisted_8
          ])
        ]),
        _createElementVNode("tbody", null, [
          (props.constructives.length)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                _hoisted_10,
                _hoisted_11,
                (!props.isSectionJobPage)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_12))
                  : _createCommentVNode("", true),
                (!props.isSectionJobPage)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString(constructiveTotals.value.hoursWorked), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(formatMoney)(constructiveTotals.value.total, 2, '.', '\xa0')), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.constructives, (constructive) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: constructive.name
            }, [
              _createElementVNode("td", _hoisted_15, _toDisplayString(constructive.number) + ". ", 1),
              _createElementVNode("td", _hoisted_16, _toDisplayString(constructive.name), 1),
              (!props.isSectionJobPage)
                ? (_openBlock(), _createElementBlock("td", _hoisted_17, "Чел/час"))
                : _createCommentVNode("", true),
              (!props.isSectionJobPage)
                ? (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(constructive.hoursWorked), 1))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_19, _toDisplayString(constructive.total
                            ? _unref(formatMoney)(+constructive.total, 2, '.', '\xa0')
                            : '0'), 1)
            ]))
          }), 128)),
          (props.materials.length || props.isSectionJobPage)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                _hoisted_21,
                _hoisted_22,
                (!props.isSectionJobPage)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_23))
                  : _createCommentVNode("", true),
                (!props.isSectionJobPage)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_24))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_25, _toDisplayString(_unref(formatMoney)(materialTotals.value.total, 2, '.', '\xa0')), 1)
              ]))
            : _createCommentVNode("", true),
          (!props.isSectionJobPage)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(props.materials, (material) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: material.id
                }, [
                  _hoisted_26,
                  _createElementVNode("td", _hoisted_27, _toDisplayString(material.name), 1),
                  _createElementVNode("td", _hoisted_28, _toDisplayString(material.unit), 1),
                  _createElementVNode("td", _hoisted_29, _toDisplayString(material.count), 1),
                  _createElementVNode("td", _hoisted_30, _toDisplayString(material.total
                            ? _unref(formatMoney)(+material.total, 2, '.', '\xa0')
                            : '0'), 1)
                ]))
              }), 128))
            : _createCommentVNode("", true),
          (props.isSectionJobPage)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                _hoisted_32,
                _hoisted_33,
                _createElementVNode("td", _hoisted_34, _toDisplayString(_unref(formatMoney)(0)), 1)
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.constructives, (constructive) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: constructive.name
                  }, [
                    _createElementVNode("td", _hoisted_35, _toDisplayString(constructive.number) + ". ", 1),
                    _createElementVNode("td", _hoisted_36, _toDisplayString(constructive.name), 1),
                    (!props.isSectionJobPage)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_37, "Чел/час"))
                      : _createCommentVNode("", true),
                    (!props.isSectionJobPage)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_38, _toDisplayString(constructive.hoursWorked), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", _hoisted_39, _toDisplayString(constructive.materialTotal
                            ? _unref(formatMoney)(+constructive.materialTotal, 2, '.', '\xa0')
                            : '0'), 1)
                  ]))
                }), 128)),
                _createElementVNode("tr", _hoisted_40, [
                  _hoisted_41,
                  _hoisted_42,
                  (!props.isSectionJobPage)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_43))
                    : _createCommentVNode("", true),
                  (!props.isSectionJobPage)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_44))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_45, _toDisplayString(_unref(formatMoney)(materialTotals.value.total + constructiveTotals.value.total, 2, '.', '\xa0')), 1)
                ])
              ], 64))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})